var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{attrs:{"fixed":"","placeholder":"","left-text":"返回","left-arrow":"","right-text":"儲存","title":_vm.title},on:{"click-left":_vm.cmdBack,"click-right":_vm.cmdRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }